import React from 'react';
import { Skeleton, Stack } from '@mui/material';

export default function SkeletonBlock({ rows=3 }){
  return (
    <Stack spacing={1} sx={{ my: 2 }}>
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} variant="rounded" height={36} />
      ))}
    </Stack>
  );
}

